import { styled } from '@mui/material/styles'
import { Card } from '@mui/material'
import { boxShadow } from '@/constant'

export const InfoCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '32px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
}))

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const FormCard = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  background: 'rgba(247,247,247,0.5)',
  padding: 30,
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

export const ScrollY = styled('div')(() => ({
  overflow: 'auto',
}))

export const ListWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}))
